import { useContext } from 'react'
import PreOrderContext from '../contexts/PreOrderContext'

export default function usePreOrder() {
    return useContext(PreOrderContext)
}
